import { atom } from "jotai";
import { currentUserAtom, signInAtom, signOutAtom } from "@/modules/auth/auth.atoms";
import type { AtomContainer } from "@/state";

// Thin PLUS-specific derivations over the template's auth atoms
// (src/modules/auth/auth.atoms.ts is the single source for sign-in/out and
// the Firebase user subscription). The server enforces the allowlist now —
// a rejected account surfaces as 403s from the API (see DataAtoms.isForbidden).
export class AuthAtoms {
  // biome-ignore lint/correctness/noUnusedPrivateClassMembers: held for future cross-atom wiring
  constructor(private readonly atoms: AtomContainer) {}

  public isSignedIn = atom((get) => get(currentUserAtom) !== null);

  // Firebase Auth nulls out the top-level `user.email` when the same email
  // exists under another provider (e.g. jim@squint.ai with both Google and
  // Microsoft providers). The provider-side email survives — fall back to it
  // so attribution still works.
  public email = atom((get) => {
    const user = get(currentUserAtom);
    if (!user) {
      return null;
    }
    return user.email ?? user.providerData.find((p) => p.email)?.email ?? null;
  });

  public signIn = signInAtom;
  public signOut = signOutAtom;
}
